<template>
  <div class="btn" @click="handleClick">
    <slot/>
  </div>
</template>

<script>
    export default {
        name: "ZButton",
        methods: {
            handleClick() {
                this.$emit("click")
            }
        }
    }
</script>

<style lang="scss" scoped>
  .btn {
    [data-theme*="theme2"] & {
      background: rgba(8, 107, 175, .1);
      border: 1px solid #086baf;
      color: #086baf;
    }

    [data-theme="theme1"] & {
      background: rgba(1, 240, 233, 0.1);
      border: 1px solid rgba(1, 240, 233, 1);
      color: rgba(1, 240, 233, 1);
    }


    user-select: none;
    width: 80%;
    margin: 0 auto 20px;
    height: 40px;
    line-height: 40px;
    opacity: 1;
    border-radius: 26px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
  }

  .btn:hover {
    [data-theme="theme1"] & {
      background: rgba(0, 132, 138, 1);
    }
    [data-theme*="theme2"] & {
      background:#086baf;
    }

    [data-theme="theme2_skyblue"] & {
      background:linear-gradient(180deg,rgba(72,207,255,1) 0%,rgba(0,105,155,1) 58%,rgba(0,140,203,1) 100%);
      border: 1px solid;

    }
    color: rgba(255, 255, 255, 1);
  }


  .btn[type="warning"] {
    background: rgba(255, 0, 0, 0.1);
    border: 1px solid rgba(255, 0, 0, 1);
    color: rgba(255, 0, 0, 1);
  }

  .btn[type="warning"]:hover {
    background: rgba(255, 0, 0, 1);
    color: rgba(255, 255, 255, 1);
  }
</style>



// WEBPACK FOOTER //
// src/components/TableToolBar/TButton.vue